/**
 * Preferences d'affichage de la sidebar, persistees dans localStorage.
 *
 * Volontairement dans localStorage et non sessionStorage : un reglage
 * d'affichage doit survivre a la fermeture de l'onglet. Ce sont des
 * preferences d'ergonomie, sans donnee metier - contrairement au cache de
 * navigation, qui est purge a la deconnexion.
 */
const CLE_SECTIONS = 'sidebar.sectionsOuvertes';
const CLE_COMPACT = 'sidebar.compact';

/**
 * Sections actuellement depliees, ou null si l'utilisateur n'a jamais choisi.
 * null => appliquer le defaut ; [] => l'utilisateur a tout replie.
 *
 * Invariant accordeon : au plus une section. Il est retabli ICI parce que les
 * valeurs ecrites avant le passage a l'accordeon en contiennent plusieurs ;
 * sans troncature, la branche « rechargement » de fusionnerSectionsOuvertes les
 * respecterait et le premier affichage montrerait plusieurs sections depliees.
 */
export const lireSectionsOuvertes = () => {
  try {
    const brut = localStorage.getItem(CLE_SECTIONS);
    if (brut === null) return null;
    const valeur = JSON.parse(brut);
    return Array.isArray(valeur) ? valeur.slice(0, 1) : null;
  } catch {
    return null;
  }
};

export const ecrireSectionsOuvertes = (sections) => {
  try {
    localStorage.setItem(CLE_SECTIONS, JSON.stringify(sections));
  } catch {
    // Quota depasse ou navigation privee : la preference est perdue, pas l'appli.
  }
};

export const lireModeCompact = () => {
  try {
    return localStorage.getItem(CLE_COMPACT) === 'true';
  } catch {
    return false;
  }
};

export const ecrireModeCompact = (compact) => {
  try {
    localStorage.setItem(CLE_COMPACT, String(compact));
  } catch {
    // idem
  }
};
